import { useWeb3React } from '@web3-react/core';
import useSWR from 'swr';
import { verifyChainConfig } from '../../helpers';
// import { IUserManager__factory } from '../../config/contracts/typechain';
// import { config } from '../../config/config';
import { parseEther } from 'ethers/lib/utils';

const useUserFee = () => {
    const { account, library, chainId } = useWeb3React();

    const { data, error } = useSWR(
        account && library && chainId ? ['userFee', account, library, chainId] : null,
        async (_, userAddress, library, chainId) => {
            if (!verifyChainConfig(chainId)) return;

            // const userManagerContract = IUserManager__factory.connect(
            //     config.addresses[chainId].userManager,
            //     library
            // );

            // const fee = await userManagerContract.getUserFee(userAddress);

            return parseEther('1');
        }
    );

    return {
        userFee: data,
        isLoading: !data && !error,
        error,
    };
};

export default useUserFee;
